<template lang="pug">
v-container(fluid class="tw-min-h-screen tw-bg-blueGray-50 tw-py-10")
  v-container(class="tw-max-w-4xl")
    v-row(justify="space-between" align="center" class="tw-mb-10")
      v-col(cols="auto")
        router-link(to="/" aria-label="Kubiqa home")
          v-img(src="@/assets/images/kubiqa-logo.svg" width="150px")
      v-col(cols="auto")
        v-btn(text color="#2f53c9" to="/") Back to Kubiqa
    v-card(flat class="tw-bg-white tw-rounded-lg tw-p-6 md:tw-p-12")
      article(class="legal-page")
        h1 Terms of Service
        p(class="legal-page__updated") Last updated: September 13, 2026

        h2 Agreement to these terms
        p These Terms of Service govern your use of Kubiqa. Kubiqa is operated by PLOP Corp, a Delaware corporation ("PLOP Corp," "we," "us," or "our"). By creating an account or using Kubiqa, you agree to these terms.

        h2 Permitted use and accounts
        p You may use Kubiqa only in compliance with applicable law and these terms. You are responsible for maintaining the confidentiality of your account credentials, for activity under your account, and for ensuring that people you authorize to use your account comply with these terms.

        h2 Customer content and responsibilities
        p You retain responsibility for customer content you provide to Kubiqa, including property, listing, contact, and other business data. You represent that you have the rights and permissions necessary to provide customer content and instruct us to process it to provide Kubiqa. Do not use Kubiqa to upload unlawful, infringing, harmful, or unauthorized content.

        h2 Availability and changes
        p We may modify, maintain, or discontinue parts of Kubiqa from time to time. We will use reasonable efforts to keep Kubiqa available, but it may be unavailable due to maintenance, technical issues, or events outside our control.

        h2 Disclaimers
        p Kubiqa is provided on an "as is" and "as available" basis. To the extent permitted by law, PLOP Corp disclaims all warranties, whether express, implied, or statutory, including warranties of merchantability, fitness for a particular purpose, and non-infringement.

        h2 Limitation of liability
        p To the extent permitted by law, PLOP Corp will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, or for lost profits, revenues, data, or business opportunities arising from or related to Kubiqa.

        h2 Termination
        p You may stop using Kubiqa at any time. We may suspend or terminate access if we reasonably believe that you have violated these terms, created risk for Kubiqa or others, or if required by law.

        h2 Updates to these terms
        p We may update these terms as Kubiqa changes. The updated terms will be posted here with a revised date. Your continued use of Kubiqa after the effective date of updated terms means you accept them.

        h2 Governing law and contact
        p These terms are governed by the laws of the State of Delaware, without regard to conflict-of-law principles. For questions about these terms, contact us at
          |
          a(href="mailto:paulino@yukas.com") paulino@yukas.com.
</template>

<script>
export default {
  name: 'Terms',
};
</script>

<style scoped lang="scss">
.legal-page {
  color: #344054;
  font-size: 1rem;
  line-height: 1.7;
}

.legal-page h1,
.legal-page h2 {
  color: #1d2939;
}

.legal-page h1 {
  font-size: 2.25rem;
  margin-bottom: 0.25rem;
}

.legal-page h2 {
  font-size: 1.25rem;
  margin: 2rem 0 0.5rem;
}

.legal-page__updated {
  color: #667085;
}

.legal-page a {
  color: #2f53c9;
}
</style>
